<div class="flex overflow-hidden w-full max-h-full mt-8">
  <div class="flex min-w-0 h-full xl:px-90 md:px-20 sm:px-3">
    <ul>
      <li *ngFor="let breadcrumb of breadcrumbs(); let last = last; let first = first">
        <a class="text-xl text-primary font-semibold underline" *ngIf="breadcrumb.url" [routerLink]="breadcrumb.url">{{ breadcrumb.label }}</a>
        <a class="text-xl text-primary font-semibold underline" *ngIf="breadcrumb.externalUrl" [href]="breadcrumb.externalUrl" target="_blank" rel="noopener">{{ breadcrumb.label }}</a>
        <!--<span class="text-xl text-primary font-semibold" *ngIf="last" >{{ breadcrumb.label }}</span>-->
      </li>
    </ul>
  </div>
</div>
